import {
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";
import { throttle } from "lodash";
import { useEffect, useState } from "react";
import refreshTokens from "./refreshToken";

const REFRESH_TOKEN_TIME = 1000 * 60 * 5;

export default function useFetchToken(
  instance: IPublicClientApplication,
  inProgress: InteractionStatus
) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial token fetch - runs once when ready
    const initTokens = async () => {
      if (
        instance?.getAllAccounts().length &&
        inProgress === InteractionStatus.None
      ) {
        try {
          await refreshTokens(instance.getAllAccounts());
        } catch (error) {
          console.error("Initial token refresh failed:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    initTokens();

    // Throttled refresh on user activity
    const handler = throttle(async () => {
      if (
        !(
          instance?.getAllAccounts().length &&
          inProgress === InteractionStatus.None
        )
      )
        return;

      await refreshTokens(instance.getAllAccounts());
    }, REFRESH_TOKEN_TIME);

    document.addEventListener("mousemove", handler);
    document.addEventListener("keypress", handler);

    return () => {
      document.removeEventListener("mousemove", handler);
      document.removeEventListener("keypress", handler);
      handler.cancel();
    };
  }, [instance, inProgress]);

  return { loading };
}

export { useFetchToken };
